import badgeLocation from '../../static/img/badge-location.png'
import badgeFriend from '../../static/img/badge-friend.png'
import badgeLanguage from '../../static/img/badge-language.png'
import badgeRating from '../../static/img/badge-note.png'

export const TimeSlotLabel = Object.freeze({
	TOP_RATING: {
		id: 'top_rating',
		badge: badgeRating,
		descriptionKey: 'time_slot_label_top_rating'
	},
	AFFILIATE_TOP_RATING: {
		id: 'top_affiliate_rating',
		badge: badgeRating,
		descriptionKey: 'time_slot_label_top_affiliate_rating'
	},
	NEIGHBOURHOOD: {
		id: 'neighbourhood',
		badge: badgeLocation,
		descriptionKey: 'time_slot_label_neighbourhood'
	},
	RECENT_BOOKING: {
		id: 'recent_booking',
		badge: badgeLocation,
		descriptionKey: 'time_slot_label_recent_booking'
	},
	FRIEND: {
		id: 'friend',
		badge: badgeFriend,
		descriptionKey: 'time_slot_label_friend'
	},
	LANGUAGE: {
		id: 'language',
		badge: badgeLanguage,
		descriptionKey: 'time_slot_label_language'
	}
})


// WEBPACK FOOTER //
// ./src/components/bookingflow/timeSlotLabel.js